// export const apibaseurl = "https://nestfin.app:8443";

// export const apibaseurl = "http://10.53.147.75:34340";

// local server url
// export const apibaseurl = "http://192.168.1.13:34340";
// export const apibaseurl = "http://192.168.1.5:34340";

// Live Server URL
export const apibaseurl = "https://cloud.nestfin.app";
// export const apibaseurl = "http://192.168.1.19:34340";

function setCity() {
  const storedCity = localStorage.getItem("selectedCity");
  const storedCityId = localStorage.getItem("selectedCityId");

  console.log(storedCity, "storedCity");
  console.log(storedCityId, "storedCity");

  if (!storedCity && !storedCityId) {
    localStorage.setItem("selectedCity", "Delhi");
    localStorage.setItem("selectedCityId", "1");
  }
}
setCity();

export function formatIndianNumber(amount: any) {
  if (!amount) return "0";
  const x = amount.toString().split(".");
  let integerPart = x[0];
  let lastThree = integerPart.slice(-3);
  const otherNumbers = integerPart.slice(0, -3);
  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }
  const formatted =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  return formatted + (x[1] ? "." + x[1] : "");
}

// localStorage.setItem("selectedCity", "Delhi")
// localStorage.setItem("selectedCityId", "1")

// export const apibaseurl = "https://weconnect.bizclockinfotech.com:9090"
export const localHostUrl = "http://localhost:3000/";
export const jwttoken = localStorage.getItem("token") || "";

// console.log(leadIdFromStorage, "leadIdFromStorage envir");
// export const leadIdFromStorage = localStorage.getItem("lead_profile_id");
export const leadIdFromStorage = localStorage.getItem("lead_profile_id") ?? "";

export const login = "/api/leads/v1/login";
export const verifyOtp = "/api/leads/v1/verify-otp";
export const localityUrl = "/api/leads/v1/get-pref-localities";
export const viewLeadProfile = "/api/leads/v1/view-lead-profile";
export const fetchPropertyByFilters = "/api/leads/v1/fetch-property-by-filters";
export const fetchPremiumProperty =
  "/api/leads/v1/fetch_premium_propertynearme";

export const getPropertyById = "/api/leads/v1/get-property-by-id";
export const getRoomOptionsById = "/api/leads/v1/get-room-options-by-id";
export const propertyTanantAdd = "/api/tanant/v1/web-tanant-add";
export const propertyTanantBooking = "/api/tanant/v1/property-tanant-booking";
export const propertyTanantAgreementDetails =
  "/api/tanant/v1/update-tanant-move-in-date";
export const updateLeadProfile = "/api/leads/v1/update-lead-profile";
export const getBookingsByTenant = "/api/tanant/v1/get-bookings-by-tenant";
export const contactUs = "/api/tanant/v1/tenant-contact-us";
export const recentSearchProperties =
  "/api/leads/v1/fetch-recent-search-properties";
export const getLeadsBookings = "/api/leads/v1/get-leads-bookings";
export const updatePaymentStatus = "/api/tanant/v1/update-payment-status";
export const webCallLead = "/api/leads/v1/web-call-lead";
export const fetchLocality = "/api/leads/v1/fetchproperty";
export const fetchBudgetFriendly = "/api/leads/v1/fetchbudget";
export const fetchNearMe = "/api/leads/v1/fetchpropertynearme";
export const similarProperty = "/api/leads/v1/fetchsimilarproperty";

export const downloadBookingReceipt = "/api/leads/v1/download-bookings-invoice";
export const fetchBookingAmount = "/api/leads/v1/booking-amount";

export const accessToken = localStorage.getItem("accessToken") || "";
export const selectedCity = localStorage.getItem("selectedCity") || "";

// export const selectedLatLng =  JSON.parse(localStorage.getItem("selectedLatLng") || "");

// environment.ts

export const getFormattedCities = (): string => {
  const selectedCityRaw = localStorage.getItem("selectedCity");

  if (!selectedCityRaw) return "";

  try {
    const cities: string[] = JSON.parse(selectedCityRaw);
    // Filter out empty strings and join with comma
    return cities.filter((c) => c.trim() !== "").join(", ");
  } catch {
    return selectedCityRaw; // fallback if plain string
  }
};

//  export getSelectedLatLng
